module.exports = __webpack_public_path__ + "img/Anexia-PeeringPortal-white.9e4d4048.svg";